'use client'

import type { HeadingBlockProps } from '@/blocks/HeadingBlock/HeadingBlock'
import { HeadingBlock } from '@/blocks/HeadingBlock/HeadingBlock'
import { type ExpectedBlockType, type SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { filterByBlockType } from '@/services/storyblok/Storyblok.helpers'
import { type BaseImageRendererProps, ImageBlockRenderer } from './ImageBlockRenderer'
import { bodyWrapper } from './ImageBlock.css'

export type ImageBlockProps = SbBaseBlockProps<
  BaseImageRendererProps & {
    body?: ExpectedBlockType<HeadingBlockProps>
  }
>

export const ImageBlock = ({ blok, nested }: ImageBlockProps) => {
  const headingBlocks = filterByBlockType(blok.body, HeadingBlock.blockName)

  return (
    <ImageBlockRenderer blok={blok} nested={nested}>
      <div className={bodyWrapper}>
        {headingBlocks.map((nestedBlock) => (
          <HeadingBlock key={nestedBlock._uid} blok={nestedBlock} />
        ))}
      </div>
    </ImageBlockRenderer>
  )
}
ImageBlock.blockName = 'image'
